import { FormStep, FormStepHeader } from './form/form-step';
import { UserTable } from './user-table';
import { useGetUsersInOrg } from '@/api/queries/useGetUsersInOrg';
import { User } from '@/api/types/backend-dto-types';

interface UsersStepProps {
  addedUsers: User[];
  onUserChange: (users: User[]) => void;
  matterCreatorId?: string;
}

export function UsersStep({ addedUsers, onUserChange, matterCreatorId }: UsersStepProps) {
  const { data: users } = useGetUsersInOrg();

  return (
    <FormStep>
      <FormStepHeader
        title="Team Members"
        description="Add team members to your matter, who will be able to view all documents and facts within the matter."
        icon="lucide--users-round"
      />

      <UserTable
        users={users ?? []}
        matterCreatorId={matterCreatorId}
        addedUsers={addedUsers}
        onUserChange={onUserChange}
      />
    </FormStep>
  );
}
